import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophyStar } from '@fortawesome/pro-duotone-svg-icons';
import { faPeopleGroup } from '@fortawesome/pro-duotone-svg-icons';
import { faLandmark as faLandmarkRegular } from '@fortawesome/pro-regular-svg-icons';
import { faBriefcase } from '@fortawesome/pro-duotone-svg-icons';
import { faUserGraduate } from '@fortawesome/pro-duotone-svg-icons';
import { faDiploma } from '@fortawesome/pro-duotone-svg-icons';
import { faLandmarkFlag } from '@fortawesome/pro-duotone-svg-icons';
import { faUserDoctorHairLong } from '@fortawesome/pro-duotone-svg-icons';
import SpecialtyLicense from "../assets/images/specialty_license.svg";
import HigherEdCash from "../assets/images/higher_ed_cash.svg";
import StateRevEx from "../assets/images/state_rvex.svg";
import HigherEd from "../assets/images/higher_ed.svg";
import EmployeeSearch from "../assets/images/employee_search.svg";
import HighestPaidEmployee from "../assets/images/highest_paid_employees.svg";
import EntityCompensation from "../assets/images/entity_compensation.svg";
import TransactionDetails from "../assets/images/transaction_details.svg";
import EntityOverview from "../assets/images/entity_overview.svg";
import DQIDashboard from "../assets/images/dqi_dashboard.svg";
import FDDDashboard from "../assets/images/fdd.svg";
import CaresDashboard from "../assets/images/cares_dashboard.svg";
import ARPADashboard from "../assets/images/arpa_dashboard.svg";
import VendorSearch from "../assets/images/vendor_search.svg";
import HighestPaidVendors from "../assets/images/highest_paid_vendors.svg";
import JobTitleHighestPaid from "../assets/images/job_title_highest_paid.svg";
import JobTitleCommon from "../assets/images/job_title_common.svg";
import JobTitleLG from "../assets/images/job_title_lg.svg";
import JobTitleWageTrends from "../assets/images/job_title_wage_trends.svg";
import JobTitleCompare from "../assets/images/job_title_compare.svg";
import JobTitleSearch from "../assets/images/job_title_search.svg";
import TeacherPay from "../assets/images/teacher_pay.svg";
import LeaSpending from "../assets/images/lea_spending_and_performance.svg";
import TeacherVsAdminPay from "../assets/images/teacher_vs_admin_pay.svg";
import EducationFunding from "../assets/images/education_funding.svg";
import EntityOverviewPurple from "../assets/images/entity_overview_purple.svg";
import EntityOneOverview from "../assets/images/title_i_program.svg";
import PropertyValues from "../assets/images/property_values.svg";
import HealthCost from "../assets/images/health_cost.svg";
import CannabisTool from "../assets/images/cannabis_tool.svg";
import BreadCrumbs from './BreadCrumbs';
import FeatureNav from './FeatureNav';
import FooterSection from './FooterSection';
import HeaderComponent from './HeaderComponent';
import '../assets/styles/main.css';

const AllPages = () => {
  return (
    <div className="all-pages">
      <HeaderComponent />
      <FeatureNav />
      <BreadCrumbs />
      {/* Popular Tools */}
      <div className="popular-tools" id="popular-tools">
        <section className="mt-20">
          <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
            <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
              <h3 className="text-light">
                <FontAwesomeIcon icon={faTrophyStar} className="me-2" />
                Popular Tools
              </h3>
              <p className="lead">
                Explore the most popular tools on Transparent Utah
              </p>
            </div>

            <div className="col-12 bg-light ">
              <div className="row justify-content-center px-3">
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://transparent.utah.gov/specialty-license-report/" title="Specialty License Plates">
                    <div className="card-header text-center text-white px-0" style={{ backgroundColor: "var(--tu-teal)" }}>Specialty License Plates
                      <sup>
                        <span
                          className="badge badge-info ms-1">New
                        </span>
                      </sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={SpecialtyLicense}
                      data-holder-rendered=" true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        Learn about changes in license plate trends over the last 5 years with an animated visualization
                      </p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://transparent.utah.gov//he-cash/" title="Higher Education">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Higher Education - Cash <sup><span
                      className="badge badge-info ms-1">New</span></sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={HigherEdCash}
                      data-holder-rendered=" true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">View Cash, Cash Equivalents, and Cash Flows in Higher Education </p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/state_rvex.php" title="State Revenue & Expenditure">
                    <div className="card-header text-center text-white px-0" style={{ backgroundColor: "var(--tu-teal)" }}>State Revenues & Expenditures <sup><span
                      className="badge badge-info ms-1">New</span></sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={StateRevEx}
                      data-holder-rendered=" true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Take a 20 year deep-dive into the Revenues and Expenditures for which
                        the
                        state is financially accountable. </p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/higher-education/higher-education-expenditure" title="Higher Education">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Higher Education Expenditure <sup><span
                      className="badge badge-info ms-1">New</span></sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={HigherEd}
                      data-holder-rendered=" true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Explore how public funds are appropriated in Utah's Higher Education
                        System </p>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Employee Compensation */}
      <div className="employee-pages" id="employee-pages">
        <section className="mt-20">
          <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
            <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
              <h3 className="text-light">
                <FontAwesomeIcon icon={faPeopleGroup} className="me-2" />
                Employee Compensation
              </h3>
              <p className="lead">
                Use these tools to search State and Local Government compensation.
              </p>
            </div>

            <div className="col-12 bg-light ">
              <div className="row justify-content-center px-3">
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/employees/employee-search" title=" Employee Search">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Employee Pay Search</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={EmployeeSearch}
                      data-holder-rendered="true"
                    />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Search for an employee's compensation</p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/employees/highest-paid-employees" title="Highest Paid Employees">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Highest Paid Employees</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={HighestPaidEmployee}
                      data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Examine an Entity's highest paid employees</p>
                    </div>
                  </a>
                </article>

                  <article className="col-auto py-3">
                    <a className="card mb-4 box-shadow h-100" target="_blank" 
                    rel="noopener noreferrer" href="/entities/compensation-downloader" title="Compensation Downloader">
                      <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Compensation Downloader</div>
                      <img className="card-img-top" alt="Thumbnail [100%x150]" src={EntityCompensation}
                      data-holder-rendered="true"/>
                      <div className="card-body py-0">
                      <p className="card-text text-center">Download ALL of an entity's compensation data</p>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Entities */}
      <div className="entity-pages" id="entity-pages">
        <section className="mt-20">
          <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
            <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
              <h3 className="text-light">
                <FontAwesomeIcon icon={faLandmarkRegular} className="me-2" />
                Entity
              </h3>
              <p className="lead">
                Use these tools to learn about governmental entity revenue, expenditure, and compliance
              </p>
            </div>

            <div className="col-12 bg-light">
              <div className="row justify-content-center px-3">
                {/* Transaction Details */}
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/transaction_details.php" title="Transaction Details">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Transaction Details</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={TransactionDetails} />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        Inspect an Entity's transactions
                      </p>
                    </div>
                  </a>
                </article>

                {/* Entity Overview */}
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/entities/entity-overview-dashboard" title="Entity Overview">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Entity Overview</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={EntityOverview} />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Investigate an Entity's revenue and expenditure</p>
                    </div>
                  </a>
                </article>

                {/* Data Quality Dashboard */}
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/dqi_dashboard.php" title="Data Quality Dashboard">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Data Quality Dashboard</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={DQIDashboard} />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        Examine the quality of the data submitted to Transparent Utah
                      </p>
                    </div>
                  </a>
                </article>

                {/* Fiscal Distress Dashboard */}
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/fdd.php" title="Fiscal Distress Dashboard">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Fiscal Distress Dashboard</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={FDDDashboard} />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Analyze an entity's fiscal distress indicators</p>
                    </div>
                  </a>
                </article>

                {/* CARES Dashboard */}
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/cares_dashboard.php" title="CARES Dashboard">
                    <div className="card-header text-center text-white bg-blue400" style={{ backgroundColor: "var(--tu-teal)" }}>CARES Dashboard</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={CaresDashboard} />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Explore a detailed CARES dashboard</p>
                    </div>
                  </a>
                </article>

                {/* ARPA Dashboard */}
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/arpa_dashboard.php" title="ARPA Dashboard">
                    <div className="card-header text-center text-white bg-blue400" style={{ backgroundColor: "var(--tu-teal)" }}>ARPA Dashboard</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={ARPADashboard} />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Explore a detailed ARPA dashboard</p>
                    </div>
                  </a>
                </article>

                {/* Vendor Payment Search */}
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/entities/vendor-payments-search" title="Vendors Payments">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Vendor Payment Search</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={VendorSearch} />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Search for a vendor's payments</p>
                    </div>
                  </a>
                </article>

                {/* Highest Paid Vendors */}
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/entities/highest-paid-vendors" title="Highest Paid Vendors">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Highest Paid Vendors</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={HighestPaidVendors} />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Examine an entity's highest paid vendors</p>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Job Title Compensation */}
      <div className="job-title-compensation" id="job-title-compensation">
        <section className="mt-20">
          <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
            <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
              <h3 className="text-light">
                <FontAwesomeIcon icon={faBriefcase} />
                Job Title Compensation
              </h3>
              <p className="lead">Use these tools to compare compensation by Job Title or Occupation</p>
            </div>

            <div className="col-12 bg-light">
              <div className="row justify-content-center px-3 text-dark">
                <div className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/employees/employee-search" title="Highest Paid">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Highest Paid</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={JobTitleHighestPaid} data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Discover the highest paying jobs and occupations</p>
                    </div>
                  </a>
                </div>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/employees/most-common-jobs" title="Most Common">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Most Common</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={JobTitleCommon} data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Examine a curated dataset of the most common jobs in Utah</p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/employees/local-government-jobs" title="Local Government Jobs">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Local Government</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={JobTitleLG} data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Find out the compensation packages for local government jobs</p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/employees/job-title-wage-trends" title="Wage Trends">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Wage Trends</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={JobTitleWageTrends} data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Examine wage trends and analytics across time for a given occupation</p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/entities/compare-two-entities" title="Compare Two Entities">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Compare Two Entities</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={JobTitleCompare} data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Compare and contrast two entity's compensation data side by side</p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/employees/job-title-search" title="Custom Search">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Custom Search</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={JobTitleSearch} data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Search across utah job titles using a custom search term. Size Limits apply.</p>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Public Education */}
      <div className="public-education" id="public-education">
        <section className="mt-20">
          <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
            <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
              <h3 className="text-light">
                <FontAwesomeIcon icon={faUserGraduate} className="me-2" />
                Public Education (K-12)
              </h3>
              <p className="lead">Use these tools to examine performance and spending at K-12 Local Education Agencies (LEA) </p>
            </div>

            <div className="col-12 bg-light ">
              <div className="row justify-content-center">
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://transparent.utah.gov/teacher-pay/" title="Project Kids">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-cool-grey)" }}>Teacher Pay <sup><span
                      className="badge badge-light">New</span></sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={TeacherPay}
                      data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Examine trends in teacher pay across LEAs and schools</p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://transparent.utah.gov/spending-map/" title="Project Kids"
                  >
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-cool-grey)" }}>Performance and Spending <sup><span
                      className="badge badge-light">New</span></sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={LeaSpending}
                      data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Compare school spending, performance, and demographics in the State of Utah.</p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://lea-pay-dash-778714388561.us-west3.run.app/" title="Project Kids"
                  >
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Aaron Bullen's Administrator & Teacher Pay <sup><span
                      className="badge badge-info ms-1">New</span></sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={TeacherVsAdminPay}
                      data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        We would like to thank Aaron Bullen for his suggestion of this dashboard. It compares teacher, administrator, and support staff compensation trends.
                      </p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://transparent.utah.gov/lea-revenue/" title="Project Kids"
                  >
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-cool-grey)" }}>Jamie Renda's Utah Education Funding <sup><span
                      className="badge badge-light">New</span></sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={EducationFunding}
                      data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">We would like to thank Jamie Renda (Path Forward Utah) for her suggestion of this dashboard. It explores how schools in Utah are funded.</p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/entity_details.php" title="Entity Overview">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Entity Overview </div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={EntityOverviewPurple}
                      data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        View LEA revenue, expenditure, and if an LEA has a surplus/deficit
                      </p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/pkids_title_i.php" title="Project Kids"
                  >
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Title I Program Effectiveness <sup><span
                      className="badge badge-info ms-1">Legacy</span></sup> </div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={EntityOneOverview}
                      data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        Learn about spending performance trends at Title I
                      </p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://old.transparent.utah.gov/pkids_legacy_dashboards_menu.php" title="Project Kids"
                  >
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Other Legacy Dashboards?</div>
                    <div className="card-body py-0 ">
                      <p className="card-text text-center mt-2">Legacy dashboards are still accessible, but not updated. The "Performance and Spending" dashboard replaces the legacy tools</p>
                      <div className="card-body py-0 d-flex justify-content-center">
                        <div className="btn btn-secondary text-center">
                          Visit Legacy Dashboards
                        </div>
                      </div>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Higher Education */}
      <div className="higher-education" id="higher-education">
        <section className="mt-20">
          <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
            <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
              <h3 className="text-light">
                <FontAwesomeIcon icon={faDiploma} className="me-2" />
                Higher Education
              </h3>
              <p className="lead">Use these tools to examine annual financial report data from Institutions of Higher Education </p>
            </div>

            <div className="col-12 bg-light ">
              <div className="row justify-content-center px-3">
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://transparent.utah.gov//he-cash/" title="Higher Education">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Higher Education - Cash <sup><span
                      className="badge badge-info ms-1">New</span></sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={HigherEdCash}
                      data-holder-rendered=" true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">View Cash, Cash Equivalents, and Cash Flows in Higher Education </p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="/higher-education/higher-education-expenditure" title="Higher Education">
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Higher Education Expenditure <sup><span
                      className="badge badge-info ms-1">New</span></sup></div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={HigherEd}
                      data-holder-rendered=" true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        Explore how public funds are appropriated in Utah's Higher Education System
                      </p>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* State of Utah */}
      <div className="state-of-utah" id="state-of-utah">
        <section className="mt-20">
          <div
            className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0"
            style={{ backgroundColor: "var(--tu-teal)" }}
          >
            <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
              <h3 className="text-light">
                <FontAwesomeIcon icon={faLandmarkFlag} className="me-2" />
                State of Utah
              </h3>
              <p className="lead">
                Use these tools for statewide analysis
              </p>
            </div>

            <div className="col-12 bg-light">
              <div className="row justify-content-center px-3">
                {/* Property Values Card */}
                <article className="col-auto py-3">
                  <a
                    className="card mb-4 box-shadow h-100"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://old.transparent.utah.gov/property.php"
                    title="Property Values"
                  >
                    <div
                      className="card-header text-center text-white"
                      style={{ backgroundColor: "var(--tu-teal)" }}
                    >
                      Property Values
                    </div>
                    <img
                      className="card-img-top"
                      alt="Property Values Thumbnail"
                      src={PropertyValues}
                      data-holder-rendered="true"
                    />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        Examine property assessments across the state
                      </p>
                    </div>
                  </a>
                </article>

                {/* State Revenues & Expenditures Card */}
                <article className="col-auto py-3">
                  <a
                    className="card mb-4 box-shadow h-100"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://old.transparent.utah.gov/state_rvex.php"
                    title="State Revenue & Expenditure"
                  >
                    <div
                      className="card-header text-center text-white px-0"
                      style={{ backgroundColor: "var(--tu-teal)" }}
                    >
                      State Revenues & Expenditures{" "}
                      <span className="badge bg-info ms-1">New</span>
                    </div>
                    <img
                      className="card-img-top"
                      alt="State Revenues & Expenditures Thumbnail"
                      src={StateRevEx}
                      data-holder-rendered="true"
                    />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        Take a 20-year deep dive into the Revenues and Expenditures
                        for which the state is financially accountable.
                      </p>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* HealthCare */}
      <div className="healthcare" id="healthcare">
        <section className="mt-20">
          <div className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)" }}>
            <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px" }}>
              <h3 className="text-light">
                <FontAwesomeIcon icon={faUserDoctorHairLong} className="me-2" />
                Healthcare
              </h3>
              <p className="lead">
                Use these tools to research health care claim costs
              </p>
            </div>

            <div className="col-12 bg-light ">
              <div className="row justify-content-center px-3">
                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://healthcost.utah.gov/" title="Health Cost Compare"
                  >
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Health Cost Compare</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={HealthCost}
                      data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">Compare common healthcare procedure prices</p>
                    </div>
                  </a>
                </article>

                <article className="col-auto py-3">
                  <a className="card mb-4 box-shadow h-100" target="_blank"
                    rel="noopener noreferrer" href="https://healthcost.utah.gov/cannabis.php" title="Medical Cannabis"
                  >
                    <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)" }}>Medical Cannabis</div>
                    <img className="card-img-top" alt="Thumbnail [100%x150]" src={CannabisTool}
                      data-holder-rendered="true" />
                    <div className="card-body py-0">
                      <p className="card-text text-center">
                        Compare prices for Qualified Medical Providers for Medical Cannabis Cards
                      </p>
                    </div>
                  </a>
                </article>
              </div>
            </div>
          </div>
        </section>
      </div>
      <FooterSection />
    </div>
  )
}

export default AllPages;